export default __webpack_public_path__ + "static/media/motivations.76883fe6.wav";